/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UpgradeLink_organization$ref: FragmentReference;
declare export opaque type UpgradeLink_organization$fragmentType: UpgradeLink_organization$ref;
export type UpgradeLink_organization = {|
  +onRestrictedPlan: boolean,
  +viewerIsAdmin: boolean,
  +viewer: {|
    +routes: {|
      +editAccountPath: string
    |}
  |},
  +$refType: UpgradeLink_organization$ref,
|};
export type UpgradeLink_organization$data = UpgradeLink_organization;
export type UpgradeLink_organization$key = {
  +$data?: UpgradeLink_organization$data,
  +$fragmentRefs: UpgradeLink_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpgradeLink_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onRestrictedPlan",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerIsAdmin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Routes",
          "kind": "LinkedField",
          "name": "routes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "editAccountPath",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '39ab049bf4bc95505db35c5e307b54c3';

module.exports = node;
